import { SPlainButton } from 'components/Button/styles';
import { sharedFieldStyles } from 'components/Forms/lib/styles';
import deviceSize from 'constants/deviceSize';
import Female from 'images/icons/Female.svg?react';
import Male from 'images/icons/Male.svg?react';
import styled from 'styled-components';
import { SColumn, SRow, SSpacedRow } from 'styles/layout';

export const STitle = styled.h1`
    font-size: 2.4rem;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 0;
`;

export const SActions = styled(SRow)`
    gap: 1rem;
`;

export const SWrapper = styled(SColumn)`
    gap: 3rem;
`;

export const SColumnResponsive = styled(SColumn)`
    @media (max-width: ${deviceSize.mobile}px) {
        flex-direction: row;
        align-items: baseline;
        margin-bottom: 1rem;

        span {
            margin-left: 1rem;
        }
    }
`;

export const SSpacedRowResponsive = styled(SSpacedRow)`
    @media (max-width: ${deviceSize.mobile}px) {
        flex-direction: column;
    }
`;

export const SSearchInput = styled.div`
    width: 23rem;
    position: relative;

    input {
        ${sharedFieldStyles}
        height: 4rem;
        padding-left: 15px;
        padding-right: 15px;
    }

    @media (max-width: ${deviceSize.mobile}px) {
        width: 100%;
    }
`;

export const SPremiumDiv = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-60%, 20%);
`;

export const SPremiumButtonDiv = styled.div`
    position: absolute;
    left: -18px;
    bottom: 20px;
    transform: translate(-10%, 50%);
`;

export const SRight = styled(SRow)`
    gap: 1rem;
`;

export const SRightResponsive = styled(SRight)`
    @media (max-width: ${deviceSize.mobile}px) {
        flex-direction: column;

        a {
            width: 100%;
        }
    }
`;

export const SCard = styled.div<{ isEven: boolean }>`
    background-color: ${({ theme, isEven }) => (isEven ? theme.color.grey.lighter : theme.color.white)};
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const SCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const SCardHeaderLeft = styled.div`
    display: flex;
    gap: 1rem;
`;

export const SCardHeaderContact = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const SCardLine = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const SCardLineLeft = styled.span`
    color: ${({ theme }) => theme.color.grey.light};
    font-weight: bold;
`;

export const SCardLineRight = styled.span``;

export const SMale = styled(Male)`
    width: 3rem;
    height: 3rem;
`;

export const SFemale = styled(Female)`
    width: 3rem;
    height: 3rem;
`;

export const SButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: flex-end;
`;

export const SImportButton = styled(SPlainButton)`
    position: relative;
`;

export const SScrollContainer = styled.div`
    width: 100%;
`;

export const SCardListInner = styled.div`
    position: relative;
    width: 100%;
`;

export const SVirtualCard = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
`;
